/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import MessageInbound from 'uplisting-frontend/components/ui/booking/messages/message/inbound';
import MessageOutbound from 'uplisting-frontend/components/ui/booking/messages/message/outbound';
import type { RhsRecord } from 'uplisting-frontend/utils/rhs/types';

interface IArgs {
  record: RhsRecord;
  message: ModelRegistry['message'];
  saveReplyRoute: string;
  showTranslation: boolean;
}

export interface BookingMessagesMessageSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingMessagesMessageComponent extends Component<BookingMessagesMessageSignature> {
  @cached
  get messageComponent(): typeof MessageInbound | typeof MessageOutbound {
    return this.args.message.inbound ? MessageInbound : MessageOutbound;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Messages::Message': typeof UiBookingMessagesMessageComponent;
  }
}
